module.exports = __webpack_public_path__ + "img/hometeacher-logo.d987c682.png";